<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="dashboardSaveAsDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-base font-semibold"
    >Draft {{ dashboard.dashboardId }}</div
  >

  <div
    data-cy="dashboardSaveAsDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow select-none text-left text-2xl font-semibold"
    >Save As</div
  >

  <div
    data-cy="dashboardSaveAsDialogNewDashboardCheckbox"
    class="flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="newDashboardOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': saveAs === dashboardSaveAsEnum.NEW_DASHBOARD
        }"
      >
        <m-check-icon
          *ngIf="saveAs === dashboardSaveAsEnum.NEW_DASHBOARD"
        ></m-check-icon>
      </div>

      <div class="ml-5 text-base">New Dashboard</div>
    </div>
  </div>

  <div
    data-cy="dashboardSaveAsDialogExistingDashboardCheckbox"
    class="mt-5 flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="existingDashboardOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD
        }"
      >
        <m-check-icon
          *ngIf="saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD"
        ></m-check-icon>
      </div>

      <div class="ml-5 flex flex-shrink-0 text-base"
        >Replace Existing Dashboard</div
      >
    </div>

    <div class="ml-5 flex flex-row items-center">
      <div
        class="relative mx-5 flex h-2 w-9 flex-shrink-0"
        *ngIf="
          !dashboardUnits &&
          saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD
        "
      >
        <ngx-spinner
          [ngClass]="{
            invisible: saveAs !== dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD
          }"
          class="invisible"
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        >
        </ngx-spinner>
      </div>

      <ng-select
        #dashboardSaveAsDialogExistingDashboardSelect
        [fixNgSelectBottom]="dashboardSaveAsDialogExistingDashboardSelect"
        data-cy="dashboardSaveAsDialogExistingDashboardSelect"
        *ngIf="
          !!dashboardUnits &&
          saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD
        "
        class="w-[500px] flex-shrink-0 text-base"
        [items]="dashboardUnits"
        [searchable]="true"
        [searchFn]="existingDashboardSearchFn"
        [clearable]="false"
        [(ngModel)]="selectedDashboardId"
        (change)="selectedChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          dashboardSaveAsDialogExistingDashboardSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          dashboardSaveAsDialogExistingDashboardSelect.blur()
        "
        appendTo="body"
        bindLabel="title"
        bindValue="dashboardId"
      >
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          <div
            class="ml-1 flex flex-row"
            [tpIsEnabled]="item.canEditOrDeleteDashboard === false"
            tp="Dashboard can be modified by author and project members with ProjectAdmin or FilesEditor role. Try to save dashboard as new to become an author."
          >
            <div class="flex truncate">
              <div class="truncate">
                {{ item.title || item.dashboardId }}
              </div>
            </div>
            <div class="flex flex-grow"></div>
            <div class="ml-5 mr-5 flex flex-shrink-0 font-semibold">{{
              item.author
            }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="text-s400 mt-9 h-7 text-base">
    <div *ngIf="saveAs === dashboardSaveAsEnum.NEW_DASHBOARD">{{
      newDashboardPath
    }}</div>

    <div
      *ngIf="
        saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD &&
        !!selectedDashboardId
      "
      >{{ selectedDashboardPath }}</div
    >

    <div
      *ngIf="
        saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD &&
        !selectedDashboardId
      "
    ></div>
  </div>

  <div class="mt-9 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Title</div
      >
    </div>

    <div [formGroup]="titleForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="dashboardSaveAsDialogTitleInput"
        class="form-input border-s3 focus:border-m600 h-10 w-96 rounded"
        [ngClass]="{
          'border-r600':
            titleForm.controls['title'].invalid &&
            titleForm.controls['title'].touched
        }"
        formControlName="title"
      />
      <m-validation [control]="titleForm.controls['title']"></m-validation>
    </div>
  </div>

  <div class="mt-2 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Space</div
      >
    </div>

    <div
      class="ml-5 flex flex-col items-start"
      tp="Admin or Editor role required"
      [tpIsEnabled]="canSpecifyReportSpace === false"
    >
      <ng-select
        #dashboardSaveAsDialogSpaceSelect
        [fixNgSelectBottom]="dashboardSaveAsDialogSpaceSelect"
        data-cy="dashboardSaveAsDialogSpaceSelect"
        class="select-h-10 w-96 flex-shrink-0"
        [ngClass]="{
          'pointer-events-none': canSpecifyReportSpace === false
        }"
        [class.report-space-select-disabled]="canSpecifyReportSpace === false"
        [items]="spacesPlusEmpty"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [disabled]="canSpecifyReportSpace === false"
        [(ngModel)]="selectedSpace"
        (change)="spaceChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          dashboardSaveAsDialogSpaceSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          dashboardSaveAsDialogSpaceSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="space"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{
            item.space === emptySpaceName ? '' : item.label
          }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="mt-8 flex min-h-[100px] flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Access Roles</div
      >
    </div>

    <div class="ml-5 flex flex-col items-start">
      <div [tp]="templateAccessRoles" [tpIsEnabled]="roles.length === 0">
        <ng-template #templateAccessRoles>
          <div>Project has no roles</div>
        </ng-template>

        <ng-select
          #dashboardSaveAsDialogRoleSelect
          [fixNgSelectBottom]="dashboardSaveAsDialogRoleSelect"
          data-cy="dashboardSaveAsDialogRoleSelect"
          class="select-h-10 w-96 flex-shrink-0"
          [items]="roles"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [(ngModel)]="selectedAccessRoles"
          (change)="accessRolesChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            dashboardSaveAsDialogRoleSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            dashboardSaveAsDialogRoleSelect.blur()
          "
          appendTo="body"
          bindLabel="roleId"
          bindValue="roleId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="truncate rounded bg-green-200 px-2 text-base text-green-700"
              >{{ item.roleId }}</div
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate text-base">{{ item.roleId }}</div>
          </ng-template>
        </ng-select>

        <div class="ml-[14px] mt-2 flex w-96 flex-wrap gap-2 text-base">
          <span
            *ngFor="let accessRole of combinedAccessRoles"
            class="truncate rounded px-2"
            [ngClass]="{
              'bg-green-200 text-green-700': accessRole.isDirect,
              'bg-slate-200 text-slate-700': !accessRole.isDirect
            }"
          >
            {{ accessRole.role }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-9">
    <button
      data-cy="dashboardSaveAsDialogCreateButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      [ngClass]="{
        'bg-m600':
          saveAs === dashboardSaveAsEnum.NEW_DASHBOARD || !!selectedDashboardId,
        'bg-s400 cursor-default':
          saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD &&
          selectedDashboardId === undefined
      }"
      (click)="save()"
      [disabled]="
        saveAs === dashboardSaveAsEnum.REPLACE_EXISTING_DASHBOARD &&
        selectedDashboardId === undefined
      "
      >Save</button
    >

    <button
      data-cy="dashboardSaveAsDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>

<div *ngIf="alias$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="struct$ | async"></div>
